module.exports = __webpack_public_path__ + "static/media/numbers-social.36fdcd97.png";